
import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest } from "../../../api/controller/UserController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const userListState = atom({
    key: 'userListState',
    default: [],
})
export const userRoleState = atom({
  key: 'userRoleState',
  default: {
    data: [],
    ovf: false,
  },
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const userFilterActiveValueState = atom({
  key: 'userFilterActiveValueState',
  default: { label: "Yes", value: true },
})
export const userFilterTypeValueState = atom({
  key: 'userFilterTypeValueState',
  default: { label: "Admin", value: "Admin" },
})

export const userFilterState = selector({
  key: 'userFilterState',
  get: ({ get }) => (
    [
      {
          label: 'Active',
          size: 6,
          required: true,
          type: 'select',
          value: get(userFilterActiveValueState),
          list: {
            ovf: false,
            data:[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ]
          }
      },
      {
        label: 'Type',
        size: 6,
        required: true,
        type: 'select',
        value: get(userFilterTypeValueState),
        list: {
          ovf: false,
          data:[
            { label: "Admin", value: "Admin" },
            { label: "Guest", value: "Guest" },
          ]
        }
    }
    ]
  ),
  set: ({ set }, e) => {
      if(e.filterLabel === 'Active'){
          set(userFilterActiveValueState, e.value)
      } else if(e.filterLabel === 'Type'){
          set(userFilterTypeValueState, e.value)
      }
  }
})

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const userDataStructureState = selector({
    key: 'userDataStructureState',
    get: ({ get }) => (
        [{ 
            label: "Name",
            type: "text",
            order: { table: 1, form: 1 },
            create: [{ enabled: false }], update: ['same_as:create.0'], view: [ { enabled: true, size: { xs: 12, md: 4 } } ],
          },{ 
            label: "RCNO",
            type: "text",
            order: { table: 2, form: 2 },
            create: [{ enabled: false }], update: ['same_as:create.0'], view: [ { enabled: true, size: { xs: 12, md: 4 } } ],
          },{ 
            label: "Email",
            type: "email",
            order: { table: 2, form: 3 },
            create: [{ enabled: false }], update: ['same_as:create.0'], view: [ { enabled: true, size: { xs: 12, md: 4 } } ],
          },
          {
            label: "Roles",
            subFields: { label: "name", value: "id" },
            type: "multiselect",
            order: { form: 5 },
            create: [{ enabled: true, size: { xs: 12, md: 12} }], update: ['same_as:create.0'], view: [ 'same_as:create.0' ],
            list: get(userRoleState),
          }].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})